import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Row } from 'components/UI/Row';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmDeleteSerialNumberProps {
    confirmFn: (target: string) => void;
    closeFn: () => void;
    target: string;
    open: boolean;
}

const ConfirmDeleteSerialNumber: FC<ConfirmDeleteSerialNumberProps> = ({ closeFn, confirmFn, target, open }) => {
    const { t } = useTranslation();

    return (
        <Dialog aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description" open={open}>
            <DialogTitle>{t('products.confirm delete serial number')}</DialogTitle>
            <DialogContent>
                <Row padding="0 0 10px 0">{target}</Row>
                <Row>{t('products.confirm delete serial number details')}</Row>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => { closeFn(); }} color="primary">
                    {t('label.cancel')}
                </Button>
                <Button onClick={() => { confirmFn(target); }} color="secondary">
                    {t('label.confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
  
export { ConfirmDeleteSerialNumber };